<template>
    <div>
        <b-form-group :label="$t('current_collection')" class="mb-3" :class="$style.collectionForm">
            <b-form-input v-model="hash" size="sm" class="mr-3"/>
            <b-button size="sm" @click.stop="changeCollection()">{{ $t('change') }}</b-button>
        </b-form-group>

        <p>
            <span v-html="$t('collection_description_1', [this.$ls.get('userHash')])"></span>&nbsp;
            <router-link :to="`/collection/${lsHash}`">{{ `${host}/collection/${lsHash}` }}</router-link>.
            {{ $t('collection_description_2') }}
        </p>
    </div>
</template>

<script>
import bButton from 'bootstrap-vue/es/components/button/button';
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
export default {
    data () {
        return {
            hash: this.$ls.get('userHash'),
            lsHash: this.$ls.get('userHash'),
            host: `${window.location.protocoll || 'http'}://${window.location.host}`
        };
    },
    components: {
        bButton,
        bFormGroup,
        bFormInput
    },
    methods: {
        changeCollection () {
            this.$ls.set('userHash', this.hash);
            this.$emit('update');
            this.lsHash = this.hash;
        }
    }
};
</script>

<style module lang="scss">
    .collectionForm [role="group"] {
        display: inline-flex;
        // justify-content: space-between;
    }
</style>
